import {
	toastAction,
} from 'utils/toast';
import {
	IoShareOutline,
	IoLogoApple,
} from 'react-icons/io5';
import {
	VscDiffAdded,
} from 'react-icons/vsc';
import {
	MdAndroid,
	MdMoreVert,
	MdAddToHomeScreen,
} from 'react-icons/md';
import Typography, {
	TypographyType,
} from 'components/typography/karim/Typography';

const ONE_HOUR = 3600000;

const navigator: any = window.navigator;

/**
 * As far as I can tell, you cannot check specifically if it is safari
 * Because all the browsers on iOS is essentially a re-skinned Safari browser.
 */
const isNotSafari = () => {
	const {
		userAgent,
	} = navigator;
	const isChrome = !!userAgent.match(/CriOS/i);
	const isFirefox = !!userAgent.match(/FxiOS/i);
	const isEdge = !!userAgent.match(/EdgiOS/i);
	const isOpera = !!userAgent.match(/OPT/i);

	return isChrome || isFirefox || isEdge || isOpera;
};

const isIos = () => {
	const userAgent = navigator.userAgent.toLowerCase();
	return /iphone|ipad|ipod/.test( userAgent ) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

// If standalone, the app is installed on device as a pwa
const isInStandaloneMode = () =>
	(('standalone' in navigator) && (navigator.standalone)) ||
	window.matchMedia('(display-mode: standalone)')?.matches; // Is not set for test environments

const doShowPwaInstallGuide = () => {
	const installReminderDelaySeconds = 5;
	const today = new Date();
	const lastPrompt = new Date(Number(localStorage.getItem('PwaInstallGuideShown') || 0));
	const seconds = (today.getTime() - lastPrompt.getTime()) / (1000);
	const prompt = (isNaN(seconds) || seconds > installReminderDelaySeconds);

	if (prompt && 'localStorage' in window) {
		localStorage.setItem('PwaInstallGuideShown', today.getTime().toString());
	}
	return prompt;
}

// --------- IOS ---------
const InstallToastIOSHeader = () => (
	<div>
		<Typography type={TypographyType.headingsH4}>
			<IoLogoApple size={'25px'}/>
			{' '}
			Installer som en app
		</Typography>
	</div>
);

const InstallToastIOSBody = () => {
	const renderBody = (content?: JSX.Element) => (
		<div>
			<br />
			<br />
			{content}
			<Typography type={TypographyType.headingsH5}>
				Klikk på <IoShareOutline size={'21px'}/>
				<br />
				og deretter
				<br />
				'Legg til på Hjem-skjermen' {' '} <VscDiffAdded />
			</Typography>
		</div>
	);
	if (isNotSafari()) {
		return renderBody(
			<Typography type={TypographyType.headingsH5}>
				For å installere dette som en app til skrivebordet, må du åpne Safari nettleseren.< br/>< br/>
			</Typography>
		);
	}

	return renderBody();
};

const showToastIfNotInstalledOnIOS = () => {
	if (isIos() && !isInStandaloneMode() && doShowPwaInstallGuide()) {
		toastAction(<InstallToastIOSHeader />, <InstallToastIOSBody />, ONE_HOUR, 'center');
	}
}

// --------- ANDROID ---------
const InstallToastAndroidHeader = () => (
	<div>
		<Typography type={TypographyType.headingsH4}>
			<MdAndroid size={'25px'} color="#3DDC84" />
			{' '}
			Installer som en app
		</Typography>
	</div>
);

const InstallToastAndroidBody = () => (
	<div>
		<br />
		<br />
		<Typography type={TypographyType.headingsH5}>
			Klikk på <MdMoreVert size={'21px'}/>
			<br />
			og deretter 'Installér appen' {' '} <MdAddToHomeScreen />
		</Typography>
	</div>
);

const showToastIfNotInstalledOnAndroid = () => {
	if (!isIos() && !isInStandaloneMode() && doShowPwaInstallGuide()) {
		toastAction(<InstallToastAndroidHeader />, <InstallToastAndroidBody />, ONE_HOUR, 'center');
	}
}

// --------- ANDROID && IOS ---------
const showToastIfNotInstalled = () => {
	showToastIfNotInstalledOnIOS();
	showToastIfNotInstalledOnAndroid();
}

export {
	showToastIfNotInstalled,
};